import classNames from 'classnames';
import visuals from './visuals';
import './styles.scss';

const Button = ({ visual, tag = 'button', children, ...props }) => {
  const buttonClass = classNames({
    button: true,
    [`button__${visual}`]: !!visual, //If exists some visual then the css is applied
  });

  const CustomTag = tag;
  return (
    <CustomTag className={buttonClass} {...props}>
      {/* if visual exists get icon from the visuals lib */}
      {visuals[visual] && visuals[visual].icon}
      {children}
    </CustomTag>
  );
};

export default Button;
